import React from 'react';
import './KpiCard.css';

const SOURCE_LABELS = {
  quickbooks: 'Live from QuickBooks',
  catalog_estimate: 'Estimated',
  production_actuals: 'From production runs',
  pending_configuration: 'Needs COGS setup',
  not_yet_available: 'Not yet available',
};

const KpiCard = ({ title, value, change, trend, icon, source }) => {
  const isPlaceholder = value === null || value === undefined;
  const sourceLabel = source ? SOURCE_LABELS[source] : null;

  if (isPlaceholder) {
    return (
      <div className="fin-kpi-card fin-kpi-card--placeholder">
        <div className="fin-kpi-header">
          <div className="fin-kpi-icon" aria-hidden="true">{icon}</div>
        </div>
        <div className="fin-kpi-content">
          <h3 className="fin-kpi-title">{title}</h3>
          <div className="fin-kpi-value fin-kpi-value--placeholder">—</div>
          {sourceLabel && <div className="fin-kpi-source fin-kpi-source--pending">{sourceLabel}</div>}
        </div>
      </div>
    );
  }

  const getTrendClass = () => {
    switch (trend) {
      case 'up':
        return 'fin-trend-up';
      case 'down':
        return 'fin-trend-down';
      default:
        return 'fin-trend-stable';
    }
  };

  const getTrendIcon = () => {
    switch (trend) {
      case 'up':
        return '↗️';
      case 'down':
        return '↘️';
      default:
        return '→';
    }
  };

  const formatChange = (changeValue) => {
    const sign = changeValue > 0 ? '+' : '';
    return `${sign}${changeValue}%`;
  };

  return (
    <div className="fin-kpi-card">
      <div className="fin-kpi-header">
        <div className="fin-kpi-icon" aria-hidden="true">
          {icon}
        </div>
        <div className="fin-kpi-trend">
          <span className={`fin-trend-indicator ${getTrendClass()}`}>
            {getTrendIcon()}
          </span>
        </div>
      </div>

      <div className="fin-kpi-content">
        <h3 className="fin-kpi-title">{title}</h3>
        <div className="fin-kpi-value">{value}</div>
        <div className={`fin-kpi-change ${getTrendClass()}`}>
          {formatChange(change)} vs previous period
        </div>
        {sourceLabel && <div className={`fin-kpi-source fin-kpi-source--${source}`}>{sourceLabel}</div>}
      </div>

      {/* Accessibility */}
      <div className="sr-only">
        {title}: {value}, {formatChange(change)} compared to previous period, trend is {trend}
      </div>
    </div>
  );
};

export default KpiCard;
